import * as React from 'react';

import { EditingTableCellNameContext } from 'af-root/context/editingTableCellNameContext';

export const useEditingTableCellName = () => React.useContext(EditingTableCellNameContext);
